import React from "react";
import { AppTopNavi, Button, Menu, MenuItem } from "@abb/abb-common-ux-react";
import { ABB_PLUS, ABB_QR_CODE } from "../../utilities/IconConstants";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import scannerActions from "../../flux/actions/ScannerAction";
import scannerListStore from "../../flux/stores/scanner/ListStore";
import { IScannerViewData } from "../../models/scanner/ScannerViewData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../models/shared/SidebarDetail";
import Authorize from "../../utilities/Authorize";


interface INoDataNoDataOnboardingProps {
  authKey?: string;
  moduleName: string;
  onCreateClick: () => void;
  onScannerClick?: (e: any) => void;
}
interface IState {
  isSampleWithScanner: boolean;
  listData: any;
}
export default class NoDataOnboarding extends React.Component<
  INoDataNoDataOnboardingProps,
  IState
> {
  private _mount: boolean = false;
  private _listData: any = [];

  constructor(props: INoDataNoDataOnboardingProps) {
    super(props);
    this._mount = true;
    this.state = {
      isSampleWithScanner: false,
      listData: [],
    };
  }

  onScanner = () => {
    this.setState({ isSampleWithScanner: !this.state.isSampleWithScanner });
  };

  getAllScannerData = () => {
    scannerActions
      .getAll(1, 0, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "%20")
      .then(() => {
        this.setState({
          listData: this._listData,
        });
      })
      .catch((e) => console.log("Error ", e));
  };

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    this.getAllScannerData();
    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      const data = state.data.result as IScannerViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach((element) => {
        items.push(new SidebarDetail(element.id, element.name));
      });
      this._listData = items;
    });
  }

  public render() {
    return (
      <React.Fragment>
        <Translation>
          {(t) => (
            <div className="h-100">
              <div className="pageheader pl-3 pr-1">
                <div className="name-header-font float-left">
                  {t(this.props.moduleName)}
                </div>
              </div>
              <div className="onboarding p-4 mt-4">
                <div className="p-5 onboarding-folder">
                  <p className="title">
                    {t(CONSTANTS.NO)} {t(this.props.moduleName)}{" "}
                    {t(CONSTANTS.DISPLAY_MESSAGE)}
                  </p>
                  <span
                    style={{ display: "flex" }}
                    className="no-record-create-scan-buttons"
                  >
                    <Authorize scopes={[`${this.props.authKey}:Add`]}>
                      <Button
                        type="primary-black"
                        icon={ABB_PLUS}
                        text={
                          t(CONSTANTS.CREATE) + " " + t(this.props.moduleName)
                        }
                        onClick={this.props.onCreateClick}
                      />
                    </Authorize>
                    {this.props.moduleName === CONSTANTS.MODULE_SAMPLE && (
                      <Authorize scopes={[`${this.props.authKey}:Scan`]}><Button
                        type="primary-black"
                        className="no-record-scan"
                        icon={ABB_QR_CODE}
                        text={
                          t(CONSTANTS.SCAN) + " " + t(this.props.moduleName)
                        }
                        onClick={this.onScanner}
                      /></Authorize>
                    )}
                  </span>
                  {this.state.isSampleWithScanner && (
                    <div className="ul-class">
                      <Menu
                        onLostFocus={() =>
                          this.setState({ isSampleWithScanner: false })
                        }
                        style={{
                          top: "40px",
                          left: "132px",
                          width: "150px",
                          borderRadius: "2px",
                        }}
                      >
                        {this.state.listData.map((d: any, i: any) => {
                          return (
                            <MenuItem
                              key={i}
                              text={d.name}
                              onSelect={() => this.props.onScannerClick(d.id)}
                            />
                          );
                        })}
                      </Menu>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Translation>
      </React.Fragment>
    );
  }
}
